import { asset as ethereum } from '@exodus/ethereum-meta'
import { asset as ethereumholesky } from '@exodus/ethereumholesky-meta'

import { EthereumStaking, isEthereumStakingTx, MaticStakingApi } from '../staking/index.js'

const polygonStakingApi = new MaticStakingApi()
const ethereumStakingApi = new EthereumStaking(ethereum)
const ethereumHoleskyStakingApi = new EthereumStaking(ethereumholesky)

export const decodePolygonStakingTxInputAmount = (tx) => {
  const {
    data: { data: txInput },
  } = tx

  const {
    values: [amount], // stake or unstake amount
  } = polygonStakingApi.validatorShareContract.decodeInput(txInput)

  return amount
}

export const calculateRewardsFromStakeTx = ({ tx, currency }) => {
  const stakedAmount = currency.baseUnit(decodePolygonStakingTxInputAmount(tx))
  const { rewards } = tx.data
  // stake tx might have rewards in it,
  // i.e: https://etherscan.io/tx/0x0a81d266109034a3a70c6f1b9601c105d8caebbd0de652a0619344f9559ae4fa
  // thus reward = txInputAmount(amount to stake) - tx.coinAmount
  // tx.coinAmount is already computed from monitor; incoming - outgoing ERC20 token txs
  const stakeTxContainsReward = !stakedAmount.equals(tx.coinAmount.abs())

  if (rewards) {
    // cache rewards
    return rewards
  }

  if (stakeTxContainsReward) {
    const txAmount = stakedAmount.sub(tx.coinAmount.abs()).abs()
    // eslint-disable-next-line @exodus/mutable/no-param-reassign-prop-only -- TODO: Fix this the next time the file is edited.
    return txAmount.toDefaultString()
  }
}

export const decodeEthLikeStakingTxInputAmount = (tx) => {
  const {
    data: { data: txInput },
    coinName: assetName,
  } = tx

  const ethereumLikeContracts = {
    ethereum: ethereumStakingApi,
    ethereumholesky: ethereumHoleskyStakingApi,
  }

  const ethLikeContract = ethereumLikeContracts[assetName]

  const {
    values: [amount], // stake or unstake amount
  } = ethLikeContract.contractPool.decodeInput(txInput)

  return amount
}

// TODO: fix this in eth libraries
export const isEthereumUndelegateTx = (tx) =>
  isEthereumStakingTx(tx) && tx.data?.methodId === EthereumStaking.METHODS_IDS.UNSTAKE

export const isEthereumTxCountedForRewards = (tx) => !!tx.data?.countedForRewards
